<script lang="ts">
	import { List } from '@wiseed/wikit';

	export let results;
	export let isFetching = false;
</script>

<List
	items={results}
	classNames="no-list-style z-1 divide-y divide-grey-light absolute top-full left-0 w-full bg-white shadow px-2 max-h-[300px] overflow-auto rounded-b"
	itemsClassNames="py-3 cursor-pointer"
	{isFetching}
/>
